
const COMMON_SCOPES = 'read_content,write_content,read_themes,write_themes,read_products,write_products,read_product_listings,read_customers,write_customers,read_orders,write_orders,write_order_edits,read_draft_orders,write_draft_orders,read_inventory,write_inventory,read_locations,read_script_tags,write_script_tags,read_fulfillments,write_fulfillments,read_assigned_fulfillment_orders,write_assigned_fulfillment_orders,read_merchant_managed_fulfillment_orders,write_merchant_managed_fulfillment_orders,read_third_party_fulfillment_orders,write_third_party_fulfillment_orders,read_shipping,write_shipping,read_analytics,read_gift_cards,write_gift_cards,read_checkouts,write_checkouts,read_reports,write_reports,read_price_rules,write_price_rules,read_discounts,write_discounts,read_marketing_events,write_marketing_events,read_resource_feedbacks,write_resource_feedbacks,read_shopify_payments_payouts,read_shopify_payments_disputes,read_translations,write_translations,read_locales,write_locales';


const envConfig = {
  local: {
    APP_HOST: 'https://emotive-embedded.loca.lt',
    API_HOST: 'https://emotive-login.loca.lt',
    SMAUG_GRAPHQL_URI: 'http://smaug.loca.lt/shopify_graphql',
    LOGIN_API: 'https://api-dev.emotiveapp.dev',
    SHOPIFY_PARTNER_API_KEY: "a7704b089b067fc3c2730ea3aabebbb7", // Create a new dev app for local development and replace this with your app's api key
    SCOPES: COMMON_SCOPES
  },
  dev: {
    APP_HOST: 'https://setup-shop.dev-emotive.com',
    API_HOST: 'https://uswe2-dev-sensus.dev-emotive.com',
    SMAUG_GRAPHQL_URI: 'https://pay.emotve.co/shopify_graphql',
    LOGIN_API: 'https://api-gw.uswe2-dev-sensus.dev-emotive.com',
    SHOPIFY_PARTNER_API_KEY: "bdcbce313c336deb85154a2737e54f6c", // Emotive Dev App https://dev.shopify.com/dashboard/129422728/apps/282903674881
    SCOPES: COMMON_SCOPES + ',read_all_orders'
  },
  prod: {
    APP_HOST: 'https://setup-shop.emotiveapp.co',
    API_HOST: 'https://www.emotiveapp.co',
    SMAUG_GRAPHQL_URI: 'https://pay.emotve.co/shopify_graphql',
    LOGIN_API: 'https://api-gw.emotiveapp.co',
    SHOPIFY_PARTNER_API_KEY: "b86b67ddff9a50c04c70f955780d0de9",
    SCOPES: COMMON_SCOPES + ',read_all_orders'
  }
};

const env = process.env.REACT_APP_BUILD_ENV || 'local';

const config = envConfig[env] || envConfig.local;

export const { APP_HOST, API_HOST, SMAUG_GRAPHQL_URI, LOGIN_API, SHOPIFY_PARTNER_API_KEY, SCOPES,  } = config;

export const SUCCESS = 'SUCCESS';
